import { TableColumnsType } from 'antd';
import { DataCertificates } from 'store/ducks/Reportings/types';

export const certificateColumnsICTSystems: TableColumnsType<DataCertificates> =
  [
    {
      title: 'Certificate registry',
      width: 150,
      dataIndex: 'certificate_registry',
      key: 'certificate_registry',
    },
    {
      title: 'Contractual arrangement name',
      width: 150,
      dataIndex: 'contractual_arrangement_name',
      key: 'contractual_arrangement_name',
    },
    {
      title: 'Date of certificate register',
      width: 150,
      dataIndex: 'date_of_certificate_register',
      key: 'date_of_certificate_register',
    },
    {
      title: 'Date of issuance',
      width: 150,
      dataIndex: 'date_of_issuance',
      key: 'date_of_issuance',
    },
    {
      title: 'Description',
      width: 150,
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Certificate Valid to',
      width: 150,
      dataIndex: 'end_date',
      key: 'end_date',
    },
    {
      title: 'ICT Service description',
      width: 150,
      dataIndex: 'ict_service_description',
      key: 'ict_service_description',
    },
    {
      title: 'ICT System name',
      width: 150,
      dataIndex: 'ict_system_name',
      key: 'ict_system_name',
    },
    {
      title: 'Name of entity',
      width: 150,
      dataIndex: 'name_of_entity',
      key: 'name_of_entity',
    },
    {
      title: 'Certificate Valid from',
      width: 150,
      dataIndex: 'start_date',
      key: 'start_date',
    },
    {
      title: 'Third party service provider name',
      width: 150,
      dataIndex: 'third_party_provider_name',
      key: 'third_party_provider_name',
    },
    {
      title: 'Validity',
      width: 150,
      dataIndex: 'validity',
      key: 'validity',
    },
  ];
